function About() {
  const l1 = [
    "https://en.intactiwiki.org/wiki/Intactivist_groups",
    "https://en.intactiwiki.org/wiki/Category:Person",
    "https://en.intactiwiki.org/wiki/Circumcision#Risks_and_effects"
  ]
  const l2 = [
    "https://www.intactglobal.org/",
    "https://www.galdef.org/",
    "https://www.cirp.org/",
    "https://www.doctorsopposingcircumcision.org/",
    "https://intaction.org/",
    "https://intactamerica.org/",
    "https://15square.org.uk/",
    "https://www.darboninstitute.org/",
    "https://www.circinfo.org/index.php",
    "https://www.bloodstainedmen.com",
    "https://cockfight.org/",
    "https://autonomycollective.org/",
    "https://circumcision.org/",
    "https://www.foregen.org/",
    "https://www.yourwholebaby.org/",
    "https://www.foreskinrevolution.com/",
  ];
  const l3 = [
    "https://www.reddit.com/r/intactivism/",
    "https://www.reddit.com/r/CircumcisionGrief/",
    "https://www.reddit.com/r/foreskin_restoration/",
    "https://www.youtube.com/@Bonobo3D",
    "https://www.youtube.com/@AttorneyClopper",
    "https://www.youtube.com/@jenna_mcclelland",
    "https://www.youtube.com/@bdmarotta",
    "https://www.youtube.com/@briandavidearp/",
    "https://www.youtube.com/@PrevailovertheSystem",
    "https://www.youtube.com/@darboninstitute",
  ];
  return (
    <div className="m-auto max-w-6xl w-3/4">
      <div className="block p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
        <h1 className="mb-2 text-2xl md:text-3xl tracking-tight text-gray-900 dark:text-white">About</h1>
        {/* <p className="font-normal text-gray-700 dark:text-gray-400">Not just slightly wrong, <i>tragically</i> wrong.</p> */}
        <p className="font-normal text-gray-700 dark:text-gray-400">
          Intactivist Directory seeks to make it easier to participate in intactivism and find support for genital-cutting-related grief. The search page provides a single, up-to-date list of events from various intactivist groups on a best-efforts basis. This aims to include activism, volunteering, support groups, meetups and more.
        </p>
        <br></br>
        <p className="font-normal text-gray-700 dark:text-gray-400">
          Intactivism is a movement dedicated to defending the rights of bodily autonomy and self-determination by opposing medically unnecessary, non-consensual genital cutting. Of particular concern are children, who are the most vulnerable members of our society. Their rights grant them the sole decision on whether or not to undergo a surgery which destroys healthy, functional genital tissue. Genital cutting breaches the right of self-determination, especially in the context of religious, aesthetic, sexual, health, and personal matters, as it robs the individual of future choice.
        </p>
        <br></br>
        <p className="font-normal text-gray-700 dark:text-gray-400">
          Circumcision is a type of genital cutting which has no medical justification when performed on a healthy child. It reduces the functionality of the genitals, causes harm to the developing brain, and can cause significant mental distress later in life. Female genital mutilation is likewise unconditionally opposed. Intersex people face a similar erosion of rights in an effort to modify their bodies to conform to societal expectations.
        </p>
        <br></br>
        <p className="font-normal text-gray-700 dark:text-gray-400">
          It is valuable to refer to these practices as Childhood Genital Cutting (CGC), as they share fundamental similarities which highlight unequal protection. Intactivism wishes to abolish CGC in pursuit of equal protection for all children, not just to prevent immediate harm, but to ensure greater wellbeing for communities as a whole. Circumcision is indefensible when subjected to an honest application of reason. It remains prevalent as a consequence of a shameful medical history, stubborn social pressures, and a host of individual defense mechanisms.
        </p>
        <blockquote class="p-4 mt-4 mb-4 border-s-4 border-gray-300 bg-gray-50 dark:border-gray-500 dark:bg-gray-800">
          <p class="font-normal leading-relaxed text-gray-700 dark:text-gray-400">
            "To cut off the uppermost skin of the secret parts is directly against the honesty of nature, and an injurious insufferable trick put upon her."
          </p>
        </blockquote>
        <p className="font-normal text-gray-700 dark:text-gray-400">
          — Dr John Bulwer, Anthropometamorphosis (London 1650), p. 213F
        </p>
        <h2 className="mb-2 mt-4 text-xl md:text-2xl tracking-tight text-gray-900 dark:text-white">Contact</h2>
        <a href="mailto:contact@intactivistdirectory.com" className="font-medium text-blue-600 dark:text-blue-500">contact@intactivistdirectory.com</a>
        <p className="font-normal text-gray-700 dark:text-gray-400">Still in development, bug reports and suggestions welcome.</p>

        <h2 className="mb-2 mt-4 text-xl md:text-2xl tracking-tight text-gray-900 dark:text-white">
          Resources
          <svg className="w-5 h-5 text-gray-800 dark:text-white inline ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" data-tooltip-target="tooltip-disclaimer" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </h2>
        <div id="tooltip-disclaimer" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 font-normal text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700 max-w-xs md:text-sm md:max-w-md whitespace-normal">
          Not extensively reviewed or endorsed, but provided for your consideration.
          <div className="tooltip-arrow" data-popper-arrow></div>
        </div>
        <div className="flex flex-col items-start">
          {l1.map((link, index) => (
            <a
              key={index}
              href={link}
              target="_blank"
              className="font-medium text-blue-600 dark:text-blue-500 hover:underline truncate inline-block max-w-full"
            >
              {link}
            </a>
          ))}
          <div className="h-4"></div>
          {l2.map((link, index) => (
            <a
              key={index}
              href={link}
              target="_blank"
              className="font-medium text-blue-600 dark:text-blue-500 hover:underline truncate inline-block max-w-full"
            >
              {link}
            </a>
          ))}
          <div className="h-4"></div>
          {l3.map((link, index) => (
            <a
              key={index}
              href={link}
              target="_blank"
              className="font-medium text-blue-600 dark:text-blue-500 hover:underline truncate inline-block max-w-full"
            >
              {link}
            </a>
          ))}
        </div>
      </div>

    </div>
  );
};

export default About;